<template>
  <div v-if="value">
    <div class="columns is-multiline">
      <div class="column is-4">
        <div class="box">
          <admin-box-item title="사용자 정보">
            <admin-form-item :customHeaderStyle="{width: '80px'}"
              isFlexAlign label="이메일">{{ value.user.email }}</admin-form-item>
            <admin-form-item :customHeaderStyle="{width: '80px'}"
              isFlexAlign label="이름">{{ value.user.last_name }}{{ value.user.name }}</admin-form-item>
            <admin-form-item :customHeaderStyle="{width: '80px'}"
              isFlexAlign label="회원번호">{{ value.user.user_num }}</admin-form-item>
            <admin-form-item :customHeaderStyle="{width: '80px'}"
              isFlexAlign label="사용자 상세">
              <router-link :to="`/office/admin/user/create?id=${value.user.id}`">
                <button class="button is-primary-light">상세보기</button>
              </router-link>
            </admin-form-item>
          </admin-box-item>
        </div>
        <div class="box">
          <admin-box-item title="신청서 정보">
            <div class="columns is-multiline">
              <div class="column is-12">
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="신청 구분">{{ value.order_type_kor }}</admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="신청번호">{{ value.reference_no }}</admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="신청일자">{{ value.created_time }}</admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="신청 상태">
                  <div>{{ value.status_kor }}</div>
                  <status-button :value.sync="value"></status-button>
                </admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}" v-if="value.file"
                                 isFlex label="신청서 추가 내용물">
                  <a :href="value.file" style="text-decoration: underline" target="_blank"
                  >{{ value.file ? value.file.split('/').slice(-1)[0] : '-' }}</a>
                </admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                                 isFlex label="사용 포인트">{{ value.point|currencyNum }}</admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                                 isFlex label="보상보험">{{ value.insurance_sign ? '가입' : '가입안함' }}</admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                                 isFlex label="파손면책">{{ value.disclaim ? '동의' : '동의안함' }}</admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                                 isFlex label="보험증권번호">{{ value.insurance_stock_number ? value.insurance_stock_number : '-' }}</admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
        <div class="box">
          <admin-box-item title="인보이스" v-if="value">
            <div class="label">인보이스 정보

              <div v-if="!editable.invoice && value.invoice" @click="clickEdit('invoice', value.invoice)"
                   class="btn-edit"><i class="material-icons-outlined">edit</i> 수정</div>
              <div v-else class="flex-align" style="gap:8px">
                <div v-if="value.invoice" class="btn-edit" @click="editable.invoice = false">취소</div>
                <div class="btn-edit" @click="saveInvoice">저장</div>
              </div>
            </div>
            <admin-form-item :customHeaderStyle="{width: '120px'}"
                             isFlex label="인보이스 번호">
              <span v-if="!editable.invoice">{{ value.invoice.invoice_number }}</span>
              <input v-else class="input-border" type="text" v-model="editData.invoice.invoice_number"
                     @keyup="e => editData.invoice.invoice_number = e.target.value">
            </admin-form-item>
            <admin-form-item :customHeaderStyle="{width: '120px'}"
                             isFlex label="실제 금액(EUR)">
              <span v-if="!editable.invoice">{{ value.invoice.price }}</span>
              <input v-else type="number" v-model.number="editData.invoice.price" class="input-border">
            </admin-form-item>
            <admin-form-item :customHeaderStyle="{width: '120px'}"
                             isFlex label="실제 금액(KRW)">
              <span v-if="!editable.invoice">{{ value.invoice.price_won|currencyNum }}</span>
              <input v-else type="number" v-model.number="editData.invoice.price_won" class="input-border">
            </admin-form-item>
            <admin-form-item :customHeaderStyle="{width: '120px'}"
                             isFlex label="인보이스 파일">
              <a v-if="!editable.invoice"
                :href="value.invoice.file" style="text-decoration: underline" target="_blank"
              >{{ value.invoice.file ? value.invoice.file.split('/').slice(-1)[0] : '-' }}</a>
              <input-single-file v-else description=""
                :value.sync="editData.invoice.file" acceptExt=".pdf"></input-single-file>
            </admin-form-item>
            <admin-form-item :customHeaderStyle="{width: '120px'}" v-if="value.country === 'fr'"
                             isFlex label="결제 링크">
              <span v-if="!editable.invoice">{{ value.invoice.account_link }}</span>
              <input v-else class="input-border" type="text" v-model="editData.invoice.account_link"
                     @keyup="e => editData.invoice.account_link = e.target.value">
            </admin-form-item>
          </admin-box-item>
        </div>

      </div>

      <div class="column is-8">
        <div class="box" v-for="(info,idx) in value.info" :key="`info-${idx}`">
          <admin-box-item :title="`신청서 ${idx + 1}`">
            <div class="columns is-multiline">
              <div class="column is-6">
                <div class="label">신청서 기본 정보
                  <div v-if="!editable.info" @click="clickEdit('info', info)"
                    class="btn-edit"><i class="material-icons-outlined">edit</i> 수정</div>
                  <div v-else class="flex-align" style="gap:8px">
                    <div class="btn-edit" @click="editable.info = false">취소</div>
                    <div class="btn-edit is-primary" @click="saveInfo(idx)">저장</div>
                  </div>
                </div>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="수취인 이름">
                  <span v-if="!editable.info">{{ info.name }}</span>
                <input v-else class="input-border" type="text" v-model="editData.info.name"
                       @keyup="e => editData.info.name = e.target.value">
                </admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="개인통관부호">
                  <span v-if="!editable.info">{{ info.pcode }}</span>
                  <input v-else class="input-border" type="text" v-model="editData.info.pcode"
                         @keyup="e => editData.info.pcode = e.target.value">
                </admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="휴대폰번호">
                  <span v-if="!editable.info">{{ info.phone }}</span>
                  <input v-else class="input-border" type="text" v-model="editData.info.phone"
                         @keyup="e => editData.info.phone = autoHyphenPhone(e.target.value)">
                </admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="전화번호">
                  <span v-if="!editable.info">{{ info.tel }}</span>
                  <input v-else class="input-border" type="text" v-model="editData.info.tel"
                         @keyup="e => editData.info.tel = autoHyphenPhone(e.target.value)">
                </admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="주소">
                  <span v-if="!editable.info">{{ info.address ? info.address.full : '' }}</span>
                  <lp-address v-else :data.sync="editData.info.address" @update:data="res => editData.info.address = res"></lp-address>
                </admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="메모">
                  <span v-if="!editable.info">{{ info.memo }}</span>
                  <textarea v-else class="input-border" v-model="editData.info.memo"
                            @keyup="e => editData.info.memo = e.target.value"></textarea>
                </admin-form-item>
              </div>
              <div class="column is-6">
                <div class="label">발송화물 정보</div>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="총 박스 수">
                  <span v-if="!editable.info">{{ info.box_quantity|currencyNum }}</span>
                  <input v-else type="number" v-model.number="editData.info.box_quantity" class="input-border">
                </admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  isFlex label="총 무게(KG)">
                  <span v-if="!editable.info">{{ info.weight }}</span>
                  <input v-else type="number" v-model.number="editData.info.weight" class="input-border">
                </admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}"
                  label="추가정보">
                  <span v-if="!editable.info">{{ info.box_info }}</span>
                  <textarea v-else class="input-border" v-model="editData.info.box_info"
                            @keyup="e => editData.info.box_info = e.target.value"></textarea>
                </admin-form-item>
                <admin-form-item :customHeaderStyle="{width: '80px'}" isFlex label="HWAB">
                  <template v-if="!editable.info">
                    <template v-if="info.parcel_number && info.parcel_number !== ''">
                      {{ info.parcel_number }}<br><span class="size-12">(업데이트 : {{ info.parcel_update_time }})</span>
                    </template>
                    <template v-else>-</template>
                  </template>
                  <input v-else class="input-border" type="text" v-model="editData.info.parcel_number"
                         @keyup="e => editData.info.parcel_number = e.target.value">
                </admin-form-item>
              </div>
              <div class="column is-full" style="margin-top:12px">
                <div class="flex-between">
                  <div class="label">발송 품목</div>
                  <div class="btn-edit" @click="clickAddProduct(idx)"><i class="material-icons">add</i> 품목 추가</div>
                </div>
                <table>
                  <tr>
                    <th>상세품목명</th>
                    <th>단가(유로)</th>
                    <th>품목 수</th>
                    <th>합계(유로)</th>
                    <th>수정/삭제</th>
                  </tr>
                  <tr v-for="(item,pIdx) in info.products" :key="`prod-${pIdx}`">
                    <td>{{ item.name }}</td>
                    <td>{{ item.price }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.total_price }}</td>
                    <td>
                      <div class="flex-center" style="gap:8px">
                        <button class="button half" @click="clickEditProduct(idx, pIdx, item)">수정</button>
                        <button class="button half is-danger" @click="clickDelProduct(idx, pIdx)">삭제</button>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
    <edit-order-product v-if="vModal" @close="onCloseModal" :infoId="selectedItem.infoId"
                        :product="selectedItem.product" @save="onSave"></edit-order-product>
  </div>
</template>

<script>
  import StatusButton from "./StatusButton";
  import LpAddress from "../../module/common/LpAddress";
  import InputSingleFile from "../../module/common/InputSingleFile";
  import EditOrderProduct from "./components/EditOrderProduct";
  export default {
    name: "OrderDetail",
    components: {EditOrderProduct, InputSingleFile, LpAddress, StatusButton},
    created() {
      this.getDetail();
    },
    data() {
      return {
        value: undefined,
        editable: {
          info: false,
          invoice: false
        },
        editData: {
          info: undefined,
          invoice: undefined
        },
        selectedItem: {
          product: undefined,
          index: 0,
          infoId: 0,
          infoIndex: 0
        },
        vModal: false
      }
    },
    methods: {
      getDetail() {
        this.$axios.get(this.getUrl(`shipagency/order/${this.$route.query.id}`)).then(res => {
          this.value = res.data;
          if(!this.value.invoice) {
            this.editData.invoice = {
              price: 0,
              price_won: 0,
              invoice_number: '',
              file: null,
              account_link: ''
            };
            this.editable.invoice = true;
          }
        });
      },
      clickEdit(key, data) {
        this.editable[key] = true;
        data = this.cloneItem(data);
        if(key === 'invoice' && data.file === undefined) {
          data.file = null;
        }
        this.editData[key] = data;
      },
      saveInfo(idx) {
        this.$axios.patch(`admin/shipagency/base_info/${this.editData.info.id}`, this.editData.info).then(res => {
          if(res.status === 200) {
            if(this.editData.info.parcel_number !== '') {
              this.editData.info.parcel_update_time = this.moment().format('YYYY-MM-DD HH:mm');
            }
            this.value.info[idx] = this.cloneItem(this.editData.info);
            this.editable.info = false;
          }
        }).catch(()=>{
          this.toast('저장 중 오류가 발생했습니다.');
        });
      },
      saveInvoice() {
        const resMethod = (res) => {
          let data = this.editData.invoice;
          if(data.file) {
            data.file = res.data.file;
          }
          this.value.invoice = data;
          this.editable.invoice = false;
        };
        if(this.editData.invoice.file === undefined) {
          this.editData.invoice.file = null;
        }
        if(this.value.invoice) {
          this.$axios.patch(`admin/shipagency/invoice/${this.editData.invoice.id}`, this.editData.invoice).then(resMethod);
        } else {
          this.$axios.post(`admin/shipagency/order/${this.value.id}/invoice`, this.editData.invoice).then(resMethod);
        }
      },
      onCloseModal() {
        setTimeout(()=>{
          this.vModal = false;
        },1000);
      },
      clickDelProduct(idx, pIdx) {
        if(confirm('품목을 삭제하시겠습니까?')) {
          this.$axios.delete(`admin/shipagency/base_info/product/${this.value.info[idx].products[pIdx].id}`).then(()=>{
            removeIndex(this.value.info[idx].products, pIdx);
          });
        }
      },
      clickEditProduct(idx, pIdx, item) {
        this.selectedItem.infoIndex = idx;
        this.selectedItem.infoId = this.value.info[idx].id;
        this.selectedItem.index = pIdx;
        this.selectedItem.product = this.cloneItem(item);
        this.vModal = true;
      },
      clickAddProduct(idx) {
        this.selectedItem = {
          infoIndex: idx,
          infoId: this.value.info[idx].id,
          index: 0,
          product: {
            id:0,
            quantity: 1,
            price: 0,
            total_price: 0,
            name: ''
          }
        };
        this.vModal = true;
      },
      onSave(res) {
        if(this.selectedItem.product.id === 0) {
          this.value.info[this.selectedItem.infoIndex].products.push(res);
        } else {
          this.value.info[this.selectedItem.infoIndex].products[this.selectedItem.index] = res;
        }
      },
      autoHyphenPhone(str) {
        str = str.replace(/[^0-9]/g, '');
        if (str.substr(0, 2) === '02') {
          if (str.length < 3) {
            return str;
          } else if (str.length < 6) {
            return this.getHyphenNum(str, 2);
          } else if (str.length < 10) {
            return this.getHyphenNum(str, 2, 3);
          } else {
            return this.getHyphenNum(str, 2, 4);
          }
        } else {
          if (str.length < 4) {
            return str;
          } else if (str.length < 7) {
            return this.getHyphenNum(str, 3);
          } else if (str.length < 11) {
            return this.getHyphenNum(str, 3, 3);
          } else {
            return this.getHyphenNum(str, 3, 4);
          }
        }
      },
      getHyphenNum(str, n1, n2=0) {
        return n2 === 0 ? `${str.substr(0, n1)}-${str.substr(n1)}`
          : `${str.substr(0, n1)}-${str.substr(n1, n2)}-${str.substr(n1 + n2)}`;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  table
    width 100%
  table, th, td
    border 1px solid #dddddd
  th, td
    padding 8px
    text-align center !important
    vertical-align middle
  th
    background-color #eee
  .label
    font-size 16px
    margin-bottom 12px !important
    display flex
    align-items center
    gap 8px
  .btn-edit
    border-radius 4px
    border 1px solid #dddddd
    font-size 12px
    padding 2px 6px
    display flex
    align-items center
    gap 4px
    cursor pointer
    font-weight 400
    i
      font-size 14px
  .is-primary
    background-color #ff5722
    color white
    border 1px solid #ff5722
  .btn-edit:hover
    background-color #fff0e5
  .is-primary:hover
    background-color #de4c1c
</style>
